export default __webpack_public_path__ + "static/media/slider7.b340fd65.jpeg";